// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3dCKJ","info":"UpdateTermsInfo_info__1otdF"};